import EmployeeContainer from "../../../Components/Workforce/Employees";
import { useEffect } from "react";
import RoleGuard from "../../RoleGuard";
import { useAppSelector } from "../../../ReduxToolkit/Hooks";
import { CRUDPermissions } from "../../../Types/Common/Access";

const Employee201File = () => {
  const { user } = useAppSelector((state) => state.auth);

  const CRUDPermissions = {
    create: true,
    read: true,
    update: true,
    delete: true,
  };

  const currentUserRoles = user?.roles?.map((role) => role.slug) || [];
  useEffect(() => {
    document.title = "Employee Directory";
  }, []);

  return (
    <>
      {/* RoleGuard ensures only allowed roles can view the page */}
      <RoleGuard
        userRoles={currentUserRoles}
        allowedRoles={["admin", "hr-officer", "hr-assistant"]}
      />

      {/* Main content */}
      <EmployeeContainer access={CRUDPermissions} />
    </>
  );
};

export default Employee201File;
